<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'AppealsPage',
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('appeals', next);
  },
};
</script>

<style lang="scss" scoped></style>
